// extracted by mini-css-extract-plugin
export var label = "_rs-0";
export var link = "_rs-1";